import { Can as RbacCan, RequirePermission as RbacRequirePermission } from '@dreamtree-org/tenancy/react';

/** "module.action.scope" for rbac-authz/react, or undefined (→ fails closed) if incomplete. */
const permission = (module, action, scope = 'org') => (module && action ? `${module}.${action}.${scope}` : undefined);

/** Conditionally render children if the user holds (module, action). Pass scope="all"
 *  for controls whose server route demands the platform-wide grant — e.g. the global
 *  connection categories/providers (routes/connectionsRouter.js). */
export default function Can({ module, action, scope = 'org', fallback = null, children }) {
  return <RbacCan do={permission(module, action, scope)} fallback={fallback}>{children}</RbacCan>;
}

/** Route-level guard: redirect to /unauthorized (the provider's Navigate) if the user lacks
 *  (module, action). Fails closed: a route that declares neither is denied. */
export function RequirePermission({ module, action, children }) {
  return <RbacRequirePermission do={permission(module, action)}>{children}</RbacRequirePermission>;
}
